// i18n
import { translateInComponent, currentLocale } from 'infras/i18n';
import translations from 'presentations/views/components/pages/AccountLeavePage/i18n.json';

import { useContext, useEffect, useState } from 'react';
import { get } from 'infras/rest_client';
import { apiPath } from 'presentations/routes/path';
import { SharedEventDetailItem } from 'presentations/api/schema/event';
import { useRouter } from 'next/router';
import { EventContactItem } from 'presentations/api/schema/event_contact';
import { SourceType } from 'domains/models/event_source/sourceType';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';

interface Props {
  event: SharedEventDetailItem;
}
export function useSharedEventPage(props: Props) {
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;
  const [event, setEvent] = useState<SharedEventDetailItem>(props.event);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [eventContact, setEventContact] = useState<EventContactItem | null>(
    null,
  );

  const { query, isReady } = useRouter();

  useEffect(() => {
    if (query && isReady) fetch();
  }, [query]);

  const t = translateInComponent(translations);

  const fetch = async () => {
    if (event.sourceType === SourceType.EventType) {
      const result = await get(apiPath(`/v1/events/${event.uid}/contact`));
      if (!result.isSuccess || !result.data) {
        setErrorMessage(t('Error'));
        return;
      }
      setEventContact(result.data);
    }
  };

  const onCloseMessage = async () => {
    setErrorMessage(null);
  };

  return {
    state: {
      event,
      eventContact,
      viewer,
      errorMessage,
    },
    actions: {
      onCloseMessage,
    },
  };
}
